<template>
  <div>
    <form
      class="mt-4"
      @submit.prevent="handleCheck"
    >
      <!-- eslint-disable-next-line max-len -->
      <p class="mt-1 font-medium">To check if a user is registered, enter the user’s email address below:</p>
      <div class="mt-1 text-sm text-gray-700">
        <label for="user-email">User's Email</label>
      </div>
      <div class="grid lg:grid-cols-12">
        <div class="col-span-10">
          <m-input
            id="user-email"
            v-model="$v.email.$model"
          />
        </div>
        <div class="col-start-12">
          <div class="relative">
            <m-button
              type="submit"
              :disabled="$v.email.$invalid || loading"
              class="text-sm font-medium w-full"
              :class="{ 'cursor-not-allowed': $v.email.$invalid || loading }"
            >
              Check
            </m-button>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue-700 rounded"
              v-if="loading"
            >
              <div class="h-4 w-4">
                <m-loader class="text-white"></m-loader>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <section class="mt-4 grid grid-cols-2" v-if="users">
      <user-info :users="users" />
      <div>
        <h3 class="font-bold text-gray-900">User Status Information</h3>
        <dl class="mt-2 text-sm grid grid-cols-3 gap-4">
          <dt class="font-medium text-gray-700">Confirmed</dt>
          <!-- eslint-disable-next-line max-len -->
          <dd class="col-span-2">Use is able to log in to Heffron IQ with their username or email address. They are also able to follow the forgot password path.</dd>
          <dt  class="font-medium text-gray-700">Unconfirmed</dt>
          <dd class="col-span-2">
            <!-- eslint-disable-next-line max-len -->
            <p>User is unable to log in to Heffron IQ. They need to confirm their email address by entering the confirmation code sent to them when they registered.</p>
            <!-- eslint-disable-next-line max-len -->
            <p>On the log in screen, they can enter their username and password to have a new confirmation code emailed to them.</p>
          </dd>
        </dl>
      </div>
    </section>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import { API, ENDPOINTS } from '@/app/services/api-url';
import EventBus from '@/app/eventBus';
import UserInfo from './user-info.vue';

export default {
  name: 'check-user',
  components: {
    UserInfo,
  },
  data() {
    return {
      email: '',
      loading: false,
      users: null,
    };
  },
  methods: {
    async handleCheck() {
      this.loading = true;
      this.users = null;
      // console.log('in handle check');
      await API.post(ENDPOINTS.POST_ADMIN_USERINFO, {
        emailAddress: this.email,
      })
        .then((res) => {
          if (res.status === 200) {
            const attributes = {};
            res.data.data.Attributes.forEach((value) => {
              attributes[value.Name] = value.Value;
            });
            this.users = [{
              username: res.data.data.Username,
              status: res.data.data.UserStatus,
              attributes,
              ownerEmailAddress: res.data.data.ownerEmailAddress,
              createdAt: res.data.data.UserCreateDate,
              updatedAt: res.data.data.UserLastModifiedDate,
            }];
            this.loading = true;
          }
        })
        .catch(() => {

        });
      if (this.loading) {
        const postData = {
          email: this.email.toLowerCase(),
        };
        // console.log('in extra search');
        const res = await API.post(ENDPOINTS.POST_USEREXISTS, postData);
        if (res.data.data.userExists && res.data.data.userStatus !== undefined) {
          const userSearchResults = res.data.data.userStatus.Users;
          const usersArray = [];
          let i = 0;
          userSearchResults.forEach((user) => {
            const attributes = {};
            user.Attributes.forEach((value) => {
              attributes[value.Name] = value.Value;
            });
            if (this.users !== null && this.users.length && i === 0
              && this.users[0].attributes.sub === attributes.sub) {
              usersArray.push(this.users[0]);
            } else {
              usersArray.push({
                username: user.Username,
                status: user.UserStatus,
                attributes,
                ownerEmailAddress: '',
                createdAt: user.UserCreateDate,
                updatedAt: user.UserLastModifiedDate,
              });
            }
            // eslint-disable-next-line no-plusplus
            i++;
          });
          this.users = usersArray;
        } else {
          EventBus.$emit('addNotification', {
            title: 'Check User',
            icon: 'cross',
            message: 'User not found',
          });
        }
        this.loading = false;
      }
    },
  },
  validations: {
    email: {
      required,
      email,
    },
  },
};
</script>

<style scoped>
</style>
